import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

class OptionMessage extends React.Component {

  static propTypes = {
    messageId: PropTypes.string.isRequired,
    optionValue: PropTypes.any.isRequired,
    values: PropTypes.object,
  };

  render() {

    let {
      t,
      messageId,
      values,
      optionValue,
    } = this.props;


    return (
      <option value={optionValue}>{t(messageId, values)}</option>
    );
  }

}

export default withTranslation()(OptionMessage);
